export const SLACK_REQUIRED_USER_SCOPES = ['channels:write', 'groups:write', 'users:read', 'team:read', 'channels:read', 'groups:read', 'users.profile:write']
export const SLACK_REQUIRED_BOT_SCOPES = ['chat:write', 'commands', 'team:read', 'users:read', 'users:read.email']
